<!-- eslint-disable -->
<template lang="pug">
    .settings(v-if='settings')
        template(v-if="parametersFrom === 'homework'")
            template
                | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}: {{ $i18n.t('trainer.trainer_gameFormSetting_' + settings.theme) }}
                br
            template(v-if='settings.amountOfExamples && !settings.infinityAmountOfExamples')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}: {{ settings.amountOfExamples }}
                br
            template
                | {{ $i18n.t('trainer.trainer_gamePlayBox_tip') }}: {{ settings.isHintEnabled ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}
                br
            template
                | {{ $i18n.t('common.common_gameName_vocabularyWords') }}: {{ settings.difficultWords ? $i18n.t('progress.progress_preview_statusOn') : $i18n.t('progress.progress_preview_statusOf') }}
                br
        slot

</template>

<script>
/*eslint-disable*/
import TrainerUtilities from '../../../utils/trainer/trainer';
import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

export default {
    mixins: [TrainerUtilities, gamePreviewMixin],
    props: {
        game: Object,
        parameters: Object,
        userId: Number,
        parametersFrom: {
            type: String,
            default: 'homework'
        }
    }
}
</script>
